// extracted by mini-css-extract-plugin
export default {"path":"CrossIcon_path__aZvOj"};